import _ from 'lodash'
import { Record, List } from 'immutable'

import { IconStyles } from 'components/Customize/Styling/IconPicker/Constants'
import { Locales } from 'components/I18n/Constants'
import { patchOperations } from 'utils/PatchHelper'
import { getTextColorForBackground } from 'utils/color'

import { FontFamilies } from './Constants'

export const Theme = Record({
  // Auidence & Targeting
  audience: '',
  userListIds: List(),
  targetId: 0,

  // Styling
  logoUrl: undefined,
  iconUrl: undefined,
  backgroundColor: undefined,
  foregroundColor: undefined,
  activeColor: undefined,
  textColor: undefined,
  widgetBackgroundColor: undefined,
  iconStyle: IconStyles.SOLID1,
  fontFamily: FontFamilies.Brandon.key,
  widgetHalfHeight: undefined,

  // Online Messaging
  unreadBadgeEnabled: null,
  userList: List(),
  userListMode: 'CUSTOM',
  welcomeMessage: null,
  emailCaptureMessage: null,
  showWelcomeMessage: false,
  captureEmail: true,
  soundNotificationEnabled: null,
  allowEndUserFileUpload: null,
  allowAgentFileUpload: null,
  titleNotificationEnabled: null,
  disableNewConversations: null,

  // Offline Messaging
  awayMessage: null,
  confirmationMessage: null,

  // Team Directory
  teamDirectoryHeading: 'Meet the Team',
  teamDirectoryDescription: null,

  timezone: undefined,
})

export const OrgSettings = Record({
  orgName: '[no name]',
  orgUrl: '',
  locale: Locales.en.key,
  showBranding: null,
  theme: Theme(),
})

export function getOrgSettingsFromEmbed(embed) {
  const {
    configuration: {
      locale,
      organizationName,
      organizationUrl,
      showBranding,
      theme: {
        activeColor,
        allowEndUserFileUpload,
        allowAgentFileUpload,
        audience,
        awayMessage,
        backgroundColor,
        captureEmail,
        confirmationMessage,
        disableNewConversations,
        emailCaptureMessage,
        foregroundColor,
        fontFamily,
        iconStyle,
        iconUrl,
        logoUrl,
        showWelcomeMessage,
        soundNotificationEnabled,
        targetId,
        teamDirectoryDescription,
        teamDirectoryHeading,
        textColor,
        timezone,
        titleNotificationEnabled,
        unreadBadgeEnabled,
        userList,
        userListIds,
        userListMode,
        welcomeMessage,
        widgetBackgroundColor,
        widgetHalfHeight,
      },
    },
  } = embed

  return OrgSettings({
    orgName: organizationName,
    orgUrl: organizationUrl,
    locale: locale || Locales.en.key,
    showBranding,
    theme: Theme({
      activeColor,
      allowEndUserFileUpload,
      allowAgentFileUpload,
      audience,
      awayMessage,
      backgroundColor,
      captureEmail,
      confirmationMessage,
      disableNewConversations,
      emailCaptureMessage,
      fontFamily,
      foregroundColor,
      iconStyle,
      iconUrl,
      logoUrl,
      showWelcomeMessage,
      soundNotificationEnabled,
      targetId,
      teamDirectoryDescription,
      teamDirectoryHeading,
      textColor: textColor || getTextColorForBackground(backgroundColor),
      timezone,
      titleNotificationEnabled,
      unreadBadgeEnabled,
      userList: List(userList),
      userListIds: List(userListIds),
      userListMode,
      welcomeMessage,
      widgetBackgroundColor,
      widgetHalfHeight,
    }),
  })
}

export function getChanges(orgSettings, initialOrgSettings) {
  const newTheme = orgSettings.theme.toJS()
  const oldTheme = _.pick(initialOrgSettings.theme, _.keys(newTheme))
  return patchOperations(
    {
      organizationName: orgSettings.orgName,
      organizationUrl: orgSettings.orgUrl,
      locale: orgSettings.locale,
      theme: newTheme,
      showBranding: orgSettings.showBranding,
    },
    {
      organizationName: initialOrgSettings.organizationName,
      organizationUrl: initialOrgSettings.orgUrl,
      locale: initialOrgSettings.locale,
      theme: oldTheme,
      showBranding: initialOrgSettings.showBranding,
    }
  )
}



// WEBPACK FOOTER //
// ./src/scripts/components/Customize/OrgSettings/Helpers.js